export default __webpack_public_path__ + "static/media/menu.4e607935.svg";